import { default as React, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Form from 'src/components/forms/Form/Form';
import TemplateWizard from 'src/modules/generic/templates/Modal/TemplateWizard';
import SubmitButton from 'src/modules/generic/components/Buttons/SubmitButton';
import * as Yup from 'yup';
import useMachine from 'src/modules/generic/context/MachineContext/useMachine';
import useTranslate from 'src/modules/generic/hooks/useTranslate';
import { clearAssistatText,addAssistantText } from 'src/modules/generic/store/action';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from "src/modules/generic/components/Texts/Typography";
import reactImage from "src/images/Group2022.png";
import classes from "./classes.module.scss";

function FormWithConciergeSuccess() {
  const { next, context } = useMachine();
  const { translate } = useTranslate();
  const dispatch = useDispatch();
  
  const initialValues = useMemo(() => {
    return context?.FormWithConciergeSuccess ?? {}
  }, [context]);
  
  const handleSubmit = async (values) => {
    next(values);
  }
  
  useEffect( ()=>{
    dispatch(
      addAssistantText(
        translate('MODULES.ONBOARDINGCOMPANY.CONCIERGE_SUCCESS_HIT')
      )
    );
    return () => {
      dispatch(clearAssistatText());
    }
  },[dispatch]);
  
  const schema = Yup.object().shape({});

  return (
    <Form
      defaultValues={initialValues}
      schema={schema}
      onlySendDirty={false}
      onSubmit={handleSubmit}
      optionsForm={ { mode: 'onChange' } }
    >
      <TemplateWizard
        props={{
          title: "Form with Clara concierge​",
          subTitle: "Clara’s Concierge​",
          skeleton: null,
          variant: 'simple'
        }}
        buttons={{
          submit: <SubmitButton isSubmitting={undefined} handleDisabled={undefined}  >{translate('BUTTON_GO_MAP')}</SubmitButton>,
        }}
      >
        <>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          spacing={3}
        >
          <Stack sx={{ width: "100%"}} gap={2}>
            <Typography component='p' variant='xbody'>
              Your company has specific needs and Clara is here to help.
            </Typography>
            <Typography component='p' variant='xbody'>
              Start by adding your shareholders and directors to the map and submit your details. Clara concierge will take it from there and get in touch with expert, personal service.
            </Typography>
          </Stack>
          <Box sx={{ width: "80%"}}>
            <Box sx={{width: "22.3077rem", position: "absolute", right: "0.7692rem", marginTop: "5.2308rem"}}>
              <img src={reactImage} alt="" className={classes.ViewCompanyFormation}/>
            </Box>
          </Box>
        </Stack>
        </>
      </TemplateWizard>
    </Form>
  );
}

export default FormWithConciergeSuccess;

